import React from 'react';
import { FaLaptopCode, FaMobileAlt, FaRobot, FaGraduationCap, FaChartLine, FaShieldAlt, FaCloud, FaServer, FaUsers, FaCode, FaDatabase, FaTools } from 'react-icons/fa';

const ServicesGridSection = () => {
  const services = [
    {
      icon: <FaLaptopCode className="service-icon" />,
      title: 'Software Development',
      description: 'Custom software solutions tailored to your business needs'
    },
    {
      icon: <FaMobileAlt className="service-icon" />,
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile applications'
    },
    {
      icon: <FaRobot className="service-icon" />,
      title: 'AI & Automation',
      description: 'Intelligent automation and AI solutions'
    },
    {
      icon: <FaGraduationCap className="service-icon" />,
      title: 'Technical Training',
      description: 'Comprehensive IT training programs'
    },
    {
      icon: <FaChartLine className="service-icon" />,
      title: 'Data Analytics',
      description: 'Actionable insights from your business data'
    },
    {
      icon: <FaShieldAlt className="service-icon" />,
      title: 'Cybersecurity',
      description: 'Comprehensive security solutions'
    },
    {
      icon: <FaCloud className="service-icon" />,
      title: 'Cloud Solutions',
      description: 'Scalable cloud infrastructure'
    },
    {
      icon: <FaServer className="service-icon" />,
      title: 'DevOps',
      description: 'Streamlined development and operations'
    },
    {
      icon: <FaUsers className="service-icon" />,
      title: 'IT Consulting',
      description: 'Expert technology guidance'
    },
    {
      icon: <FaCode className="service-icon" />,
      title: 'Web Development',
      description: 'Modern, responsive websites'
    },
    {
      icon: <FaDatabase className="service-icon" />,
      title: 'Database Management',
      description: 'Efficient data storage solutions'
    },
    {
      icon: <FaTools className="service-icon" />,
      title: 'IT Support',
      description: 'Reliable technical assistance'
    }
  ];

  return (
    <section className="services-grid-section py-5">
      <div className="container">
        <div className="section-header text-center mb-5">
          <h6 className="text-uppercase text-muted">Our Services</h6>
          <h2 className="fw-bold">What We Do</h2>
          <div className="divider mx-auto my-3"></div>
        </div>
        
        <div className="row g-4">
          {services.map((service, index) => (
            <div key={index} className="col-lg-3 col-md-4 col-sm-6">
              <div className="service-card h-100 p-4 text-center">
                <div className="icon-wrapper mb-3">
                  {service.icon}
                </div>
                <h5 className="mb-2">{service.title}</h5>
                <p className="text-muted mb-0">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .services-grid-section {
          background-color: #fff;
        }
        .section-header h2 {
          color: #333;
          font-size: 2.5rem;
        }
        .divider {
          width: 60px;
          height: 3px;
          background-color: #f4bf00;
        }
        .service-card {
          background: #fff;
          border-radius: 8px;
          transition: all 0.3s ease;
          border: 1px solid #eee;
        }
        .service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          border-color: #f4bf00;
        }
        .icon-wrapper {
          width: 70px;
          height: 70px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(244, 191, 0, 0.1);
          border-radius: 50%;
        }
        .service-icon {
          font-size: 30px;
          color: #f4bf00;
        }
        .service-card h5 {
          color: #333;
          font-weight: 600;
        }
      `}</style>
    </section>
  );
};

export default ServicesGridSection;
